import { motion } from 'framer-motion';
import { CircularProgress } from '@mui/material';

type LoadingIndicatorProps = {
  message?: string;
};

export function Loading({ message = "Carregando..." }: LoadingIndicatorProps) {
  return (
    <motion.div 
      className="d-flex justify-content-center align-items-center flex-column my-5"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <CircularProgress data-testid="loading-spinner" />
      {message && <p className="text-muted mt-2">{message}</p>}
    </motion.div>
  );
}
